export default __webpack_public_path__ + "assets/6edeb2.svg";